import React, { useState, useEffect } from 'react';
import { Select, Toast, Button, Avatar } from '@douyinfe/semi-ui';
import { IconRefresh, IconPlus, IconFile } from '@douyinfe/semi-icons';
import request from '../../utils/request';

const PageSelector = ({ value, onChange }) => {
    const [loading, setLoading] = useState(false);
    const [pageList, setPageList] = useState([]);

    const fetchPageList = async () => {
        setLoading(true);
        try {
            const response = await request.get('/go/spc/mlist_page/', {
                params: {
                    with_all_status: 1
                }
            });
            if (response.errno === 0) {
                setPageList(response.list || []);
            } else {
                Toast.error(response.errstr || '获取页面列表失败');
            }
        } catch (error) {
            console.error('获取页面列表失败:', error);
            Toast.error('获取页面列表失败');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPageList();
    }, []);

    const handleChange = (selectedUid) => {
        const selectedPage = pageList.find(page => page.uid === selectedUid);
        onChange?.({
            pageId: selectedUid,
            pageName: selectedPage?.name || ''
        });
    };

    const formatTime = (timestamp) => {
        if (!timestamp) return '-';
        const date = new Date(parseInt(timestamp));
        return date.toLocaleString();
    };

    const handleAddPage = () => {
        window.open('/h5editor', '_blank');
    };

    const renderSelectedItem = (optionNode) => {
        const selectedPage = pageList.find(page => page.uid === optionNode.value);
        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <span>{selectedPage?.name || optionNode.value}</span>
            </div>
        );
    };

    const renderCustomOption = (page) => {
        const optionStyle = {
            display: 'flex',
            paddingLeft: 24,
            paddingTop: 10,
            paddingBottom: 10,
        };
        return (
            <Select.Option
                key={page.uid}
                value={page.uid}
                style={optionStyle}
                showTick={true}
            >
                <div>
                    <div style={{ fontSize: 14 }}>{page.name}</div>
                    <div style={{ color: 'var(--semi-color-text-2)', fontSize: 12, lineHeight: '16px', fontWeight: 'normal' }}>
                        最后编辑: {formatTime(page.time)}
                    </div>
                </div>
            </Select.Option>
        );
    };

    return (
        <Select
            loading={loading}
            value={value?.pageId}
            onChange={handleChange}
            style={{ width: '100%' }}
            placeholder="请选择关联页面"
            filter
            showClear
            filterOption={(input, option) => {
                const name = option?.label?.toString() || '';
                return name.toLowerCase().includes(input.toLowerCase());
            }}
            prefix={<IconFile style={{ color: 'var(--semi-color-primary)' }} />}
            renderSelectedItem={renderSelectedItem}
            outerTopSlot={<Button
                icon={<IconRefresh />}
                type="tertiary"
                onClick={fetchPageList}
                style={{ width: '100%', marginBottom: '8px' }}
            >
                刷新列表
            </Button>}
            outerBottomSlot={<Button
                icon={<IconPlus />}
                theme="solid"
                type="primary"
                onClick={handleAddPage}
                style={{ width: '100%', marginTop: '8px' }}
            >
                新建页面
            </Button>}
        >
            {pageList.map(page => renderCustomOption(page))}
        </Select>
    );
};

export default PageSelector;